import { Location } from '@angular/common';
import { Component, EventEmitter, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { isString } from '@ng-bootstrap/ng-bootstrap/util/util';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import * as _ from 'underscore';
import { Auth } from '../shared/services/auth';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { SharedData } from '../shared/sharedData';
import { ToasterComponent } from '../toasterComponent/toasterComponent';

@Component({
  selector: 'AddGrade',
  templateUrl: 'addGrade.html'
})
export class AddGradeComponent {

  @Output() public addOrgEvent = new EventEmitter();
  public _baseUrl: any;
  public type: any = 'ADD';
  public gradeModel: any;
  public empPresent: boolean = false;
  public data: any;
  public gradedata: any = {};
  public disabled: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public _global: Configuration,
    public http: HttpClientCustom,
    public _sanitizer: DomSanitizer,
    public builder: FormBuilder,
    public _auth: Auth,
    public router: Router,
    public _location: Location,
    public translate: TranslateService,
    public share: SharedData,
    public _toaster: ToasterComponent,
    vcr: ViewContainerRef
  ) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    let data: any = this.share.getData();
    if (_.isEmpty(data)) {
      this._location.back();
    } else {
      if (data.type === 'ADD') {
        this.data = {};
        this.type = 'ADD';
      } else if (data.type === 'EDIT') {
        this.gradedata = data.gradedata;
        this.type = 'EDIT';
      } else {
        this.gradedata = data.gradedata;
        this.type = 'DELETE';
        let url = this._baseUrl + 'v1/webAdmin/grade/check/' + this.gradedata.id;
        this.http.get(url).subscribe((result) => {
          if (result.success) {
            this.empPresent = true;
          } else {
            this.empPresent = false;
          }
        });
      }
    }
    this._toaster.setViewRef(vcr);
  }
  // Formatter
  public nameValueFormatter(data: any): string {
    return `${data.name}`;
  }

  public autoCompleteListGradeFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.name}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  // To get list of designation based on keyword
  public gradeObservableSource = (keyword: any): Observable<any[]> => {
    let url = this._baseUrl + 'v1/webAdmin/grade/gradeSearch';
    url += '?searchString=' + keyword + '&id=' + this.gradedata.id;
    if (keyword.trim()) {
      return this.http.get(url)
        .map((res) => {
          return res;
        }, (error) => {
          return Observable.of([]);
        });
    } else {
      return Observable.of([]);
    }
  }

  public gotNewValue(e, type) {
    this.gradeModel = e;
  }

  // Navigate back
  public goToBackPage() {
    this._location.back();
  }

  public saveGrade() {
    if (this.validateGrade()) {
      this.disabled = true;
      let url = this._baseUrl + 'v1/webAdmin/grade/save';
      this.http.post(url, this.gradedata).subscribe((result) => {
       this.disabled = false;
        if (result.success) {
          this.translate.get('jobGradeSaved').subscribe((msg) => {
            this._toaster.showSuccess(msg);
          });
          setTimeout(() => this.goToBackPage(), 1000);

        } else {
          this.translate.get(result.errorMessages[0]).subscribe((msg) => {
            this._toaster.showError(msg);
          });
        }
      }, (error) => {
        this.translate.get('errorWhileSavingJobGrade').subscribe((msg) => {
          this._toaster.showError(msg);
          this.disabled = false;
        });
      });

    }
  }

  public deleteGrade() {
    if (this.empPresent && this.isEmpty(this.gradeModel)) {
      this.translate.get('selectAltJobGrade').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    let url = null;
    if (this.empPresent) {
      url = this._baseUrl + 'v1/webAdmin/grade/' + this.gradedata.id
        + '?alternateId=' + this.gradeModel.id;
    } else {
      url = this._baseUrl + 'v1/webAdmin/grade/' + this.gradedata.id;
    }
    this.http.delete(url).subscribe((result) => {
      if (result.success) {
        this.translate.get('jobGradeDeleted').subscribe((msg) => {
          this._toaster.showSuccess(msg);
        });
        setTimeout(() => this.goToBackPage(), 1000);
      } else {
        this.translate.get(result.errorMessages[0]).subscribe((msg) => {
          this._toaster.showError(msg);
        });
      }
    }, (error) => {
      this.translate.get('errorWhileDeletingJobGrade').subscribe((msg) => {
        this._toaster.showError(msg);
      });
    });
  }

  public isEmpty(val) {
    return !val
      || (isString(val) && !val.trim());
  }

  public validateGrade() {
    if (!this.gradedata.name || !this.gradedata.name.trim()) {
      this.translate.get('enterJobGradeNameToContinue').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (!this.gradedata.gradeCode || !this.gradedata.gradeCode.trim()) {
      this.translate.get('enterJobGradeCode').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (!this.gradedata.level || this.gradedata.level < 1) {
      this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (this.gradedata.level > 100) {
      this.translate.get('pleaseEnterLevelLessHund').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/tools/addGrade.ts